module.exports = {
	forceScope: 'art_form', // TODO: forceScope necessary since scope rework?

	extends: [
		'/',
		'templates',
		'artForm',
		'entity',
		'recordController'
	],

	config: {
		showDetailsNavButton: true
	},

	methods: {

		showEdit: function(buttonMode, addressType, addressID, addressAttributes){
			if(buttonMode === 'details' && addressAttributes){
				var baseActionKey = 'showEdit_addressDetails';
				return this.performAndStoreAction(
					baseActionKey + '_inEffect',
					this.prepareAction(baseActionKey, undefined, {
						addressAttributes: addressAttributes
					})
				);
			}
		}
	}
}